import * as React from 'react';
import Select from '../select';
const MiniSelect = (props) => React.createElement(Select, Object.assign({}, props, { showSearch: true, size: "small" }));
const MiddleSelect = (props) => React.createElement(Select, Object.assign({}, props, { showSearch: true, size: "middle" }));
MiniSelect.Option = Select.Option;
MiddleSelect.Option = Select.Option;
export { MiniSelect, MiddleSelect };
